import { useEffect, useState } from "react";
import { Result } from "@ad/anq-ui";
import styles from "./index.module.scss";

interface Props {
  promptStatement: string; // 提示语
}

const Unavailable = (props: Props) => {
  const { promptStatement } = props;
  const [seeHeight, setSeeHeight] = useState(0);
  const init = () => {
    const { clientHeight } = document.body;
    const navHeight = document.getElementsByClassName(
      "navHeader_wrap__AXCIS"
    )[0]?.clientHeight;
    setSeeHeight(clientHeight - navHeight);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div
        className={styles["result_unavailable"]}
        style={{
          height: `${seeHeight}px`,
        }}
      >
        <Result
          status="author"
          title="暂时没有使用权限"
          subTitle={<div>{promptStatement}</div>}
          extra={null}
        />
      </div>
      <style>
        {`
          .anq-result-subtitle .anq-result-subtitle-width {
            max-width: 526px;
          }
        `}
      </style>
    </>
  );
};
export default Unavailable;
